import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="copy"
export default class extends Controller {
  copy() {
    const text = this.element.innerText;
    navigator.clipboard.writeText(text);
  }
}
